import {ResponseError} from './response-error';
import {globalEventBus, globalEventNames} from './global-dispatcher';
// global exception handling - listen to uncaught errors
window.addEventListener('error', function(ev)  {
    if (ev.error instanceof ResponseError) {
        globalEventBus.$emit(globalEventNames.errorsChanged, ev.error.messages);
        ev.preventDefault();
        return true;
    }
});

// global exception handling - listen to uncaught promises rejections
window.addEventListener('unhandledrejection', (ev) => {
    if (ev.reason instanceof ResponseError) {
        globalEventBus.$emit(globalEventNames.errorsChanged, ev.reason.messages);
        ev.preventDefault();
        return true;
    }
});
//import 'babel-polyfill';

import Vue from 'vue';
import Vue2Filters from 'vue2-filters';
import VueMoment from 'vue-moment';
import ElementUI from 'element-ui';
import axios from 'axios';
import qs from 'qs';

import './global-icons';
import App from './App.vue';
import globalStore, {globalStoreMethods} from './global-store';
import globalRouter from './global-router';
import globalLanguages from './global-languages';


import {breakpoint} from './mixins/breakpoint';
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';

// definizione foglio di stile base
import './assets/scss/index.scss';

Vue.config.errorHandler = function (err)  {

    if (err instanceof ResponseError) {
        globalEventBus.$emit(globalEventNames.errorsChanged, err.messages);
    }
    else globalEventBus.$emit(globalEventNames.errorsChanged, [{text: err}]);
};

// use
Vue.use(mavonEditor);


// esposizione informazioni (disabilitare su rilascio)
Vue.config.productionTip = (process.env.VUE_APP_PRODUCTION_TIP === 'true');
Vue.config.devtools = (process.env.VUE_APP_DEV_TOOLS === 'true');

// aggancio vue2-filters
Vue.use(Vue2Filters);

// aggancio vue-moment
Vue.use(VueMoment);

// aggancio axios come gestore AJAX
Vue.prototype.$http = axios;
axios.openedRequests = 0;
Vue.use(ElementUI, {
    size: 'small',
    i18n: (key, value) => globalLanguages.t(key, value)
});

Vue.directive('resize', {
    inserted: function(el, binding) {
        const onResizeCallback = binding.value;
        window.addEventListener('resize', () => {
            const width = document.documentElement.clientWidth;
            const height = document.documentElement.clientHeight;
            onResizeCallback({ width, height });
        })
    }
});

// creazione istanza primaria Vue
const app = new Vue({
    store: globalStore,
    router: globalRouter,
    i18n: globalLanguages,

    mixins: [
        breakpoint() //import('./mixins/breakpoint')
    ],

    data: {
        clientAppToken: '',
        axiosRequests: 0,
    },

    // funzione di render
    render: h => h(App),

    // su creazione istanza ...
    async created() {

        // creazione token applicazione
        this.clientAppToken = Math.floor(1000000000000000 + Math.random() * 9000000000000000).toString(36).substr(0, 10);
        document.querySelector('html').setAttribute('client-app-token', this.clientAppToken);
        axios.defaults.headers.common['X-Client-App-Token'] = this.clientAppToken;

        //#region  Definizione interceptors

        // Le richieste marcate "background" (config.background = true) non concorrono all'overlay di attesa
        // e non producono notifiche di errore: sono dati accessori che non devono bloccare l'operatore.
        const isBackgroundRequest = (config) => !!(config && config.background);

        // Aggiornamento del contatore delle richieste attive e del relativo flag di "occupato"
        const trackRequest = (config, delta) => {
            if (isBackgroundRequest(config)) return;

            axios.openedRequests += delta;
            this.$store.commit(globalStoreMethods.mutations.setBusy, axios.openedRequests !== 0);
        };

        // Impostazione interceptors su REQUEST
        axios.interceptors.request.use(
            (config) => {
                config.paramsSerializer = params => qs.stringify(params, {arrayFormat: 'indices', allowDots: true});
                // Do something before request is sent
                trackRequest(config, +1);
                return config;
            },
            (error) => {

                // Do something with request error
                trackRequest(error && error.config, -1);
                return Promise.reject(error);

            });

        // Add a response interceptor su RESPONSE
        axios.interceptors.response.use(
            (response) => {
                // Do something with response data
                trackRequest(response.config, -1);
                if (response.data instanceof Blob) {
                    return response;
                }
                return {
                    results: response.data.results,
                    meta: response.data.meta,
                    headers: response.headers
                };
            },
            (error) => {
                const config = error && error.config;
                // Do something with response error
                trackRequest(config, -1);

                // Sulle richieste accessorie l'errore va solo propagato al chiamante, senza disturbare l'operatore
                if (isBackgroundRequest(config)) {
                    return Promise.reject(error);
                }

                // In assenza di risposta (timeout, rete o servizio irraggiungibile) resta solo il messaggio dell'errore
                if (error.response && error.response.status === 400) {
                    globalEventBus.$emit(globalEventNames.errorsChanged, error.response.data.Description.map((x) => {
                        return {text: x};
                    }));
                } else {
                    globalEventBus.$emit(globalEventNames.errorsChanged, [{text: error.message}]);
                }
            });

        //#endregion

        // inizializzazione store
        await this.$store.dispatch(globalStoreMethods.actions.init, this.clientAppToken);

        globalEventBus.$on(globalEventNames.errorsChanged, (messages) => {
            messages.forEach((message) => {
                setTimeout(() => {
                    this.$notify.error({
                        title: 'Error',
                        message: message.text
                    });
                }, 100);
            });
        });


    }

});

Date.prototype.getElementDate = function(){

    return new Date( this.setTime(this.getTime() + (-1 * this.getTimezoneOffset()*60*1000)));
}

// aggancio su componente in html
app.$mount('#app');


// esportazione applicazione di 1° livello e predisposizione elementUI
export default app;
